import { Component, ChangeDetectionStrategy, Input, OnChanges } from '@angular/core'

@Component({
  selector: 'flo-facebook-share-icon',
  template: `
    <a [href]="facebookSharerUrl" target="_blank" data-test="facebook-share">
      <div class="facebook-icon w-100 h-100">
        <span class="d-inline-block svg-vertical-align-top">
          <flo-svg-icon icon="icon-social-facebook" width="32px"></flo-svg-icon>
        </span>
      </div>
    </a>
  `,
  styleUrls: ['./facebook-share-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FacebookShareIconComponent implements OnChanges {
  @Input() shareableLink: string

  /**
   * Facebook share dialog
   * @see {@link https://developers.facebook.com/docs/workplace/sharing/share-dialog/}
   */
  public facebookSharerUrl: string

  ngOnChanges() {
    this.facebookSharerUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.shareableLink)}`
  }
}
